import { useState, useEffect, useCallback } from "react";

const useLocalStorages = (keys = []) => {

  // Lecture initiale : NE CRÉE RIEN si localStorage est vide
  const [values, setValues] = useState(() => {
    const result = {};

    keys.forEach(key => {
      const stored = window.localStorage.getItem(key);

      if (stored !== null) {
        // Valeur existante => on la charge
        result[key] = JSON.parse(stored);
      } else {
        // PAS de création ! Valeur = undefined
        result[key] = undefined;
      }
    });

    return result;
  });

  // setter pour UNE clé
  const setValue = useCallback((key, newValue) => {
    setValues(prev => {
      const updated = { ...prev, [key]: newValue };

      // Écriture dans le localStorage UNIQUEMENT ici
      window.localStorage.setItem(key, JSON.stringify(newValue));

      return updated;
    });
  }, []);

  return [values, setValue];
};

export default useLocalStorages;
